module.exports = __webpack_public_path__ + "img/interaireculturel.2d54da43.png";